import { AlertCircle } from "lucide-react"

export interface ValidationSummaryProps {
  // Accepts the shape both Fluent Validation and our helper produce
  errors?: Record<string, string[]>
}

export function ValidationSummary({ errors }: ValidationSummaryProps) {
  // 1. Strict null/empty check
  if (errors == null || Object.keys(errors).length === 0) {
    return null
  }

  // 2. Cast the entries to be explicit about the [string, string[]] shape
  const errorEntries = Object.entries(errors)

  return (
    <div className="mb-4 rounded-r-md border-l-4 border-red-500 bg-red-50 p-4">
      <div className="mb-2 flex items-center">
        <AlertCircle className="mr-2 h-5 w-5 text-red-500" />
        <h3 className="text-sm font-bold tracking-wide text-red-800 uppercase">Validation Failed</h3>
      </div>
      <ul className="list-inside list-disc space-y-1">
        {errorEntries.map(([field, messages]) => {
          // 3. Strict access: get the first message and ensure it's a string
          const firstMessage = messages[0]

          // 4. Strict boolean check for the message
          if (typeof firstMessage !== "string" || firstMessage.length === 0) {
            return null
          }

          return (
            <li key={field} className="text-sm text-red-700">
              <span className="font-semibold capitalize">{field}:</span> {firstMessage}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
